import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex md:w-176 items-start gap-4 mt-4"
}
const _hoisted_2 = {
  key: 0,
  class: "flex md:w-176 items-start gap-4 mt-4"
}
const _hoisted_3 = { class: "!mt-10 mb-10 md:!mt-12 md:!mb-12" }

import { onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { ISitecoreFormGenericInput } from '@/interfaces';
import FormStepInputs from '@/components/FormStepInputs/FormStepInputs.vue';
import { getFormInput } from '@/utils/form-input-helper';
import { PageAnalyticsBuilder } from '@/utils/page-analytics-builder';
import InformationBox from '@/components/InformationBox/InformationBox.vue';
import ContactInformationForm from './ContactInformationForm.vue';
import Divider from '@/components/Divider/Divider.vue';
import { useAccountStore } from '@/store';


export default /*@__PURE__*/_defineComponent({
  __name: 'ContactInformationPage',
  props: {
    content: {},
    id: {},
    name: {}
  },
  setup(__props: any) {

const props = __props;

const accountStore = useAccountStore();

const emailIsTaken = ref<boolean>(false);
const showInternetBankingMessage = ref<boolean>(false);

const internetBankingMessage = ref(getFormInput(props.content, 'internetBankingMessage'));
const emailAddress = ref(getFormInput(props.content, 'emailAddress'));
const phoneNumber = ref(getFormInput(props.content, 'phoneNumber'));
const additionalPhoneNumber = ref(getFormInput(props.content, 'additionalPhoneNumber'));
const profileLink = ref(getFormInput(props.content, 'profileLink'));
const emailAddressAlreadyUsedMessage = ref(getFormInput(props.content, 'emailAddressAlreadyUsedMessage'));

const dictionary = useI18n().getLocaleMessage('en') as Record<string, string>;

onMounted(() => {
  showInternetBankingMessage.value = (accountStore.identityDetails?.portfolio?.bankingProducts?.length ?? 0) > 0;
  pushAnalytics();
});

const updateEmailIsValid = (e: boolean) => {
  emailIsTaken.value = e;
};

const pushAnalytics = () => {
  const pageAnalytics = new PageAnalyticsBuilder();
  pageAnalytics.populateProducts(dictionary);
  pageAnalytics.pushAnalytics();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(FormStepInputs, {
      step: {
      stepName: _ctx.name,
      formInputs: _ctx.content,
    }
    }, {
      emailAddressAlreadyUsedMessage: _withCtx(() => [
        (emailIsTaken.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createVNode(InformationBox, {
                title: emailAddressAlreadyUsedMessage.value.title.value,
                description: emailAddressAlreadyUsedMessage.value.content.value,
                type: emailAddressAlreadyUsedMessage.value.messageType.value,
                isCircle: true,
                useButtonSlot: false
              }, null, 8, ["title", "description", "type"])
            ]))
          : _createCommentVNode("", true)
      ]),
      internetBankingMessage: _withCtx(() => [
        (showInternetBankingMessage.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(InformationBox, {
                title: internetBankingMessage.value.title.value,
                description: internetBankingMessage.value.content.value,
                type: internetBankingMessage.value.messageType.value,
                isCircle: true,
                useButtonSlot: false
              }, null, 8, ["title", "description", "type"])
            ]))
          : _createCommentVNode("", true)
      ]),
      disclaimer: _withCtx(() => _cache[1] || (_cache[1] = [])),
      _: 1
    }, 8, ["step"]),
    _createElementVNode("div", null, [
      _createVNode(ContactInformationForm, {
        emailAddressInput: emailAddress.value,
        phoneNumberInput: phoneNumber.value,
        additionalPhoneNumberInput: additionalPhoneNumber.value,
        profileLink: profileLink.value,
        content: _ctx.content,
        onEmailIsTaken: _cache[0] || (_cache[0] = (e) => updateEmailIsValid(e))
      }, null, 8, ["emailAddressInput", "phoneNumberInput", "additionalPhoneNumberInput", "profileLink", "content"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(Divider)
    ])
  ], 64))
}
}

})